{% block ecocode_trustpilot_first_run_wizard_welcome %}
<div>
    <div class="center">
        <img alt="trustpilot-logo" :src="assetFilter('ecocodetrustpilot/logo.svg')">
        <h4 class="headline-welcome">{{ $tc('ecocode-trustpilot.welcome.modalHeadline') }}</h4>
        <p
           class="text-welcome">
            {{ $tc('ecocode-trustpilot.welcome.modalBody') }}
        </p>
    </div>
</div>
{% endblock %}
